import { openInBlobInBlank } from "../../../../../common/utils/view_utils";
import { IDownloadEntregaOrdemCompraArquivoUseCase } from "../../../presentation/useCases/read/download_entrega_ordem_compra_arquivo_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DownloadEntregaOrdemCompraArquivoUseCase
 */

export class DownloadEntregaOrdemCompraArquivoUseCase implements IDownloadEntregaOrdemCompraArquivoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async downloadEntregaOrdemCompraArquivo(
    idOrdemCompra: number,
    idProdutoServicoEntregue: number,
    nomeArquivo: string,
  ): Promise<void> {
    const result = await this.repository.downloadEntregaOrdemCompraArquivo(idOrdemCompra, idProdutoServicoEntregue);
    await openInBlobInBlank(nomeArquivo, result);
  }
}
